const excludedPackagesShortNames = [
	'3ca', // 3Cat
	'als', // Alleskino
	'amo', // AMC on Demand
	'cic', // Club Illico
	'cnv', // Cineverse
	'cut', // Cranked Up TV
	'daf', // DocAlliance Films
	'koc', // Kocowa
	'kod', // Kino on Demand
	'mrp', // Mercado Play
	'mte', // Mitele
	'mvt', // MovieSaints
	'mxx', // Max
	'nxp', // Nexo Plus
	'opl', // Oneplay
	'org', // Orange VOD
	'ply', // Google Play Movies
	'rvl', // Reveel
	'snr', // Sooner
	'tak', // Takflix
	'tbv', // Tubi TV
	'tf1', // TF1
	'uat', // UAM TV
	'vld', // Videoload
	'wa4', // wedotv
	'wdt', // Wedo TV
	'yot', // Youtube
	'yrk', // Yorck on Demand
];

export function excludePackages(
	isLoggedIn: boolean,
	entityId: string | undefined,
	country: string,
	isProUser: boolean
) {
	if (isLoggedIn) {
		const excludedPackagesLoggedIn = ['mrp', 'tf1', 'wa4', 'wdt', 'cut', 'cic', 'opl'];

		if (!['US', 'CA', 'IN'].includes(country)) excludedPackagesLoggedIn.push('tbv');
		if (country === 'DE') excludedPackagesLoggedIn.push('snr');

		if (!isProUser && ['TR'].includes(country)) {
			excludedPackagesLoggedIn.push('mxx');
		}

		return excludedPackagesLoggedIn;
	}

	return excludedPackagesShortNames.filter(shortName => !shouldAllowPackageId(shortName, country));
}

// Removes packages from the excludedList based on specific conditions
function shouldAllowPackageId(shortName: string, country: string): boolean {
	if (shortName === 'tbv' && ['IN'].includes(country)) {
		return true; // Tubi allowed in India
	}
	if (shortName === 'mxx' && !['TR'].includes(country)) {
		return true; // Max allowed outside Australia, Turkey
	}

	if (shortName === 'snr' && country !== 'DE') {
		return true; // Sooner allowed outside Germany
	}
	return false;
}
